import MenuItem from '#js/atoms/MenuItem.js';
import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * Toast component
 */
export default class Menu extends withBreakpointObserver(Base) {
  submenuOpen = false;
  /**
   * Component Configuration
   */
  static config = {
    name: 'Menu',
    refs: ['close[]'],
    components: {
      MenuItem,
    },
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.currentItem = null;
  }

  /**
   *
   */
  toggleMenu() {
    toggleClass(document.body, 'menu-open');

    if (this.submenuOpen) {
      this.closeAllSubmenus();
    }
  }

  /**
   * Close all submenu when closing Menu
   * @returns {void}
   */
  closeAllSubmenus() {
    this.$children.MenuItem.forEach((element) => {
      element.closeSubmenu();
    });
  }
}
